/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-16, 12:27:08
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-19, 10:33:14
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { ShLanguageList } from '@sh/vue-component-ui/components/common';

export default {
  name: 'TheHeader',

  props: {
    language: {
      type: String,
      default: 'pl',
    },
    logoImage: {
      type: String,
      default: '/static/img/logo-small.png',
    },
  },

  components: {
    ShLanguageList,
  },

  data() {
    return {
      languageList: ['pl', 'en'],
    };
  },

  methods: {
    handleChangeLanguage(lang) {
      this.$lang.setLang(lang);
    },
  },

  watch: {
    language(lang) {
      this.$lang.setLang(lang);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/TheHeader/component.js